import React from "react";
import PropTypes from "prop-types";
import "../css/Menu.css";

const anchors = [
  "top",
  "who",
  "activities",
  "how",
  "ethics",
  "address-phone-number",
];

/**
 * Menu component
 */
class Menu extends React.Component {
  static displayName = "Menu";
  static propTypes = {
    className: PropTypes.string,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "Menu";
  }

  /**
   * @override
   */
  render() {
    return (
      <div
        className={`${this.className} ${this.props.className || ""}`}
        onClick={this.props.closeMenu}
      >
        <div className={`${this.className}__close`}>
          <svg viewBox="0 0 24 24">
            <path
              fill="#ffffff"
              d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
            />
          </svg>
        </div>
        <div className={`${this.className}__items`}>
          {this.props.items.map((item, index) => (
            <div
              className={`${this.className}__item`}
              onClick={() => this.props.goTo(anchors[index])}
            >
              {item}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js